function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.2624 15.5H20.679V10.0833C20.679 8.98329 19.354 8.41829 18.5624 9.18163L7.72904 19.5983C7.48404 19.835 7.3457 20.16 7.3457 20.5C7.3457 20.84 7.48404 21.165 7.72904 21.4016L18.5624 31.8183C19.3524 32.5783 20.679 32.0233 20.679 30.9166V25.5H30.2624C31.4107 25.5 32.3457 24.565 32.3457 23.4166V17.5833C32.3457 16.435 31.4107 15.5 30.2624 15.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.6792 40.5C9.65087 40.5 0.679199 31.5283 0.679199 20.5C0.679199 9.47167 9.65087 0.5 20.6792 0.5C31.7075 0.5 40.6792 9.47167 40.6792 20.5C40.6792 31.5283 31.7075 40.5 20.6792 40.5ZM20.6792 3.83333C11.4892 3.83333 4.01253 11.31 4.01253 20.5C4.01253 29.69 11.4892 37.1667 20.6792 37.1667C29.8692 37.1667 37.3459 29.69 37.3459 20.5C37.3459 11.31 29.8692 3.83333 20.6792 3.83333Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white",
  transform: "translate(0.679199 0.5)"
})));

function SvgPrevious(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.227afca9.svg";
export { ForwardRef as ReactComponent };